import { Box, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import { FlexWorkerLevelFilters } from 'shared/services/worker-service.types';
import { useIdSubmissionForm } from './hooks/use-id-submission-form';
import { IdScanManualStep } from './steps/id-scan-manual-step/id-scan-manual-step';
import { IdSubmissionFormProps } from './types';
import { SelfieStep } from './steps/selfie-step/selfie-step';
import { EmailFormStep } from '../../../components/common/email-form-step/email-form-step';

export const IdSubmissionForm = ({
  step,
  onNextStep,
  emailVerified,
  setEmailVerified,
}: IdSubmissionFormProps) => {
  const { t } = useTranslation('web-common');
  const { form, onSubmit, handleSelfieSuccess, handleDocumentSuccess, isSubmitting } =
    useIdSubmissionForm({
      onNextStep,
    });

  return (
    <FormProvider {...form}>
      <StyledForm onSubmit={form.handleSubmit(onSubmit)} noValidate>
        <StepsContainer>
          {emailVerified ? (
            <>
              {step === 0 ? <SelfieStep onSuccess={handleSelfieSuccess} /> : null}
              {step === 1 ? (
                <IdScanManualStep onSuccess={handleDocumentSuccess} isSubmitting={isSubmitting} />
              ) : null}
              {step === 2 ? (
                <StyledCongratulationsStep>
                  {t('id-submission.successfull-message.title')}
                </StyledCongratulationsStep>
              ) : null}
            </>
          ) : (
            <EmailFormStep
              onSuccess={() => setEmailVerified(true)}
              level={FlexWorkerLevelFilters.EXPLORER}
            />
          )}
        </StepsContainer>
      </StyledForm>
    </FormProvider>
  );
};

const StyledForm = styled('form')({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
});

const StepsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    height: 'auto',
    paddingBottom: theme.spacing(16),
  },
}));

const StyledCongratulationsStep = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  fontSize: theme.typography.h5.fontSize,
  fontWeight: theme.typography.h5.fontWeight,
  color: theme.palette.text.primary,
}));
